<template>
    <div id="rewind">
        <div class="achievement-page vh-100" id="achievement-page" data-page="0">

            <div class="ach-header">
                <div class="ach-logo"></div>
                <i class="fas fa-times f-c-white" id="btn-icon" @click="dashboard"></i>

            </div>
            <div class="load-data-rewind" style="text-align: center">
                Sedang memproses dan menyediakan data...
            </div>
            <!-- <div class="note-data-rewind" >*Data dihitung per tanggal 1 Januari 2022 s/d 30 November 2022</div> -->
            <div id="sonar">
                <div id="sonar-1"/>
                <div id="sonar-2"/>
                <div id="sonar-3"/>
            </div>
            
            <div id="main-slide" class="slide" @keyup.left="pressLeft()" @keyup.right="pressRight()" @click="onClickPage" tabindex="0">
                <li class="slide-welcome splide__slide center">
                    <img src="../../assets/img/achievement2023/Image-1.png" alt="" id="welcome-image">
                    <div id="welcome-text">
                        Catatan Perjalanan Owner <br>
                        <span>#bersamasmartlink</span> selama <span>2023</span> 
                    </div>
                </li>

                <li class="splide__slide content position-relative over-hidden" id="slide-2">
                    <div class="w-limit3 h-100 text-center prelude caption">
						<p>
							Terimakasih telah tumbuh bersama di <span class="f-c-accent">Era Digital {{year}}</span>
						</p>
                    </div>
                    <img src="../../assets/img/achievement2023/flower.png" id="img-flower" alt="">
                    <!-- <img src="../../assets/img/achievement2023/star.png" alt=""> -->
                </li>

                <li class="splide__slide content relative" id="slide-3">
                    <div class="w-limit3 h-100">
                        <div class="f-bold content-item caption">
                            <span class="f-c-accent">{{detail.count_transaksi }}</span> 
                            transaksi yang telah anda dapatkan menjadi langkah luar biasa, mencerminkan semangat Anda yang tak kenal lelah untuk terus tumbuh bersama di era digital ini.
                        </div>
                        <img src="../../assets/img/achievement2023/Image-3.png" id="img-3">
                    </div>
                </li>

                <li class="splide__slide content relative" id="slide-4">
                    <div class="w-limit3 h-100">
                        <div class="content-item caption">
                            <p>
                                
                                <span>{{detail.new_customer | decimal}} pelanggan</span> baru bergabung dalam kisah sukses Anda. 
                                <br><br>
                                Total <span>{{detail.new_customer | decimal}} pelanggan</span>, memberi bukti bahwa pertumbuhan bersama di era digital bukan sekadar kata-kata, melainkan kenyataan yang anda ciptakan bersama kami.

                            </p>
                        </div>
                    </div>
                    <img src="../../assets/img/achievement2023/Image-4a.png" alt="" id="image-4a">
                    <img src="../../assets/img/achievement2023/Image-4b.png" alt="" id="image-4b">
                    <img src="../../assets/img/achievement2023/Image-4c.png" alt="" id="image-4c">
                </li>

                <li class="splide__slide content relative" id="slide-5">
                    <div class="w-limit3 h-100">
                        <div class="content-item caption">
                            Tanpa Anda sadari, kontribusi Anda telah mendukung pertumbuhan sekitar <span class="f-c-accent">-/+{{detail.daily_average.toFixed(0) | decimal}} transaksi</span> setiap harinya, menjadi bagian tak terpisahkan dari perjalanan bersama di era digital ini.
                        </div>
                    </div>
                    <div class="image-container">
                        <div class="relative">
                            <img src="../../assets/img/achievement2023/Image-5.png" alt="" id="image-5">
                        </div>
                    </div>
                </li>

                <li class="splide__slide content relative" id="slide-6">
                    <div class="w-limit3 h-100 content-item text-left">
                        <div class="caption">
                            <span>
                                Bulan <span class="f-c-accent">{{top_month}}</span> menjadi saksi kekompakkan kita dalam tumbuh bersama di era digital.
                            </span>
                            <span class="d-block pt-4">
                                Terbukti pada bulan tersebut, kita mencatat prestasi luar biasa dengan jumlah transaksi tertinggi yang mencerminkan kolaborasi dan perkembangan kita bersama di dunia digital ini
                            </span>
                        </div>
                    </div>
                    <img src="../../assets/img/achievement2023/Image-6.png" alt="" id="image-6">
                </li>
                <li class="splide__slide content relative over-hidden" id="slide-7">
                    <div class="w-limit3 h-100 content-item">
                        <div class="f-semi caption">
                            Layanan <span class="f-c-accent" >{{detail.top1_layanan}}</span> menjadi layanan paling diminati oleh pelanggan Anda
                        </div>
                    </div>
                    <img src="../../assets/img/achievement2023/Image-7.png" id="image-7">
                </li>

                <li class="splide__slide content relative over-hidden" id="slide-8">
                    <div class="w-limit3 h-100 content-item">
                        <div class="f-semi caption">
                            Anda telah turut mendorong perkembangan ekonomi digital dengan kontribusi sebesar <span class="f-c-accent">{{detail.bayar_qris | currency}}</span> melalui penggunaan QRIS
                        </div>
                    </div>
                    <img src="../../assets/img/achievement2023/Image-8.png" alt="" id="image-8">
                    <div class="rounded-circle bg-white" id="trophy-circle"/>
                </li>

                <li class="splide__slide content relative" id="slide-9">
                    <div class="h-100 content-item text-left" style="padding-top: 40px; transition: all 500ms; margin: auto;">
                        <div class="position-relative">
                            <img :src="detail.outlet_1_url" id="outlet-image" class="">
                            <img src="../../assets/img/achievement2023/Image-9.png" width="250" alt="" id="image-9">
                        </div>
                        <div class="caption" style="padding-top: 200px">
                            <p>
                                Outlet <span class="f-c-accent">{{detail.outlet_fav[0]}}</span> 
                                <template v-if="detail.outlet_fav.length > 1">
                                    menjadi laundry terfavorit karena banyak dikunjungi oleh pelanggan
                                </template>
                                <template v-else>
                                    memiliki pelayanan cepat, hasil yang bersih, dan harga kompetitif sehingga menarik pelanggan dan menjadikan outlet {{ detail.outlet_fav[0] }} menjadi pilihan utama para pelanggan laundry 
                                </template>
                            </p>
                            <p class="m-t-16" v-if="detail.outlet_fav.length > 1">
                                Diikuti outlet
                                <span class="f-c-accent">{{detail.outlet_fav[1]}}</span>
                                <template v-if="detail.outlet_fav.length > 2"> & <span class="f-c-accent">{{detail.outlet_fav[2]}}</span></template>
                                yang menjadi outlet favorit para pelanggan anda.
                            </p>
                        </div>
                    </div>
                </li>

                <li class="splide__slide content" id="slide-10">
                    <div class="w-limit3 h-100 content-item content-item-2">
                        <div id="service-summary" class="caption poition-relative" style="padding-top: 100px">
                            <img src="../../assets/img/achievement2023/Image-10.png" alt="" id="image-10" style="top: 110px">
                            Kami sangat terkesan dengan pencapaian Anda tahun ini:
                            <ul>
                                <li v-if="detail.qty_kg>0">
                                    <span style="">{{detail.qty_kg.toFixed(0) | decimal}} Kg</span> Pakaian
                                </li>
                                <li v-if="detail.qty_satuan>0">
                                    <span style="">{{detail.qty_satuan.toFixed(0) | decimal}} Satuan</span> Dry Clean
                                </li>
                                <li v-if="detail.qty_luas>0">
                                    <span style="">{{detail.qty_luas.toFixed(0) | decimal}} M2</span> Karpet
                                </li>
                                <li v-if="detail.qty_koin>0">
                                    <span style="">{{detail.qty_koin.toFixed(0) | decimal}}</span> Koin
                                </li>
                                <li v-if="detail.count_self_service>0">
                                    <span style="">{{detail.count_self_service.toFixed(0) | decimal}} Nota</span> Self Service
                                </li>
                            </ul>
                            Dengan pelayanan yang baik!
                        </div>
                    </div>
                </li>

                <li class="splide__slide content relative" id="slide-11">
                    <div class="w-limit3 h-100 content-item content-item-2" style="padding-top: 80px">
                        <div class="f-semi ">
                            <p class="m-d-16 caption" id="thank-text">
                                <span class="no-underline f-c-accent" style="">{{nama_owner}}</span>,<br>
                                terima kasih atas dedikasi Anda dalam perjuangan untuk tumbuh bersama kami. Tantangan besar telah menanti Anda
                                <br><br>
                                Namun, yakinlah bahwa tantangan yang berat bisa dilalui <span class="f-c-accent">#bersamasmartlink</span>
                            </p>
                        </div>
                    </div>
                    <img src="../../assets/img/achievement2023/Image-11.png" id="image-11">
                </li>

                <li class="splide__slide content relative" id="slide-12">
                    <div class="w-limit2 content-desc share">
                        <div class="text-center share__header">
                            Dapatkan piagam fisik!
                        </div>
                        <div class="f-16 m-t-12 text-center share__body">
                            Untuk mengenang pencapaian {{ year }}, kami bisa mengirimkan sebuah piagam fisik ke rumah Anda.
                        </div>
                        <div class="m-t-20 action-group">
                            <button class="btn smart-primary" @click="openPreview2">
                                <i class="fa fa-trophy"></i>
                                Pesan Piagam
                            </button>
                            <button class="btn smart-secondary has-icon m-t-12" @click="() => {}">
                                <div class="icon-16 icon-share-white m-r-8"></div>
                                Share pencapaian
                            </button>
                            <div class="separator-mini m-t-20 m-d-20 op-75"></div>
                            <div class="btn-groupx flex">
                                <button class="btn smart-secondary" @click="ulangi">
                                    Ulangi Lagi
                                </button>
                                <button class="btn smart-secondary m-l-12" @click="dashboard">
                                    Keluar
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
            </div>

            <div class="ach-footer" v-if="splideIndex < 11">
                <div @click="pressRight()" class="scroll-indicator f-c-white f-bold" :class="{'right': splideIndex > 0}">
                    <div class="scroll-desc f-c-white">
                        {{splideIndex > 0 ? 'Lanjutkan' : 'Lihat Pencapaian anda tahun ini'}}
                    </div>
                    <button class="btn-nude">
                        <i class="fas fa-chevron-right f-c-white" />
                    </button>
                </div>
            </div>

            <div class="modal mod fade" id="modalPiagam" role="dialog">
                <div class="modal-dialog modal-lg bani-modal">
                    <div class="modal-content">
                        <div class="modal-headx w-limit2">
                            <div class="icon-24 icon-x-white top-right" data-dismiss="modal"></div>
                        </div>
                        <div class="modal-img">
                            <img src="../../assets/img/achievement/piagams.png" alt="">
                        </div>
                        <div class="modal-bodyy w-limit2 w-100 p-x-20 p-y-20">
	                        Ini adalah contoh piagam yang akan Anda terima. Anda bisa request data yang ingin ditampilkan.
                            <div class="button-wrapper m-t-24 w-limit w-100" @click="toCustomerService">
                                <button class="btn smart-primary" style="border: solid 1px;">Pesan melalui WA</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <SOModalConfirm
                title="Pesan Piagam"
                body="Untuk pemesanan piagam bisa menghubungi cs smartlink di whatsapp 6285234494494 atau telpon ke (0341) 4383407. Terimakasih.  "
                button-text="Ok"
                ref="pesanPiagam"
            />

        </div>

        <!--        bagikan preview-->
        <div class="preview-wrapper">
            <div class="preview-handle">
                <a id="close-rewind" href="javascript:void(0)" @click="closePreview">
	                <img src="@/assets/icons/close-white.svg" alt="">
                </a>
<!--                <a id="download-rewind"  class="btn smart-secondary" ref="printMe" download="smartlink-rewind-2020.png" :href="output">-->
<!--                    Download Gambar-->
<!--                </a>-->
	            <a class="hide" ref="printMe" download="smartlink-rewind-2021.png" :href="output">
		            Download Gambar
	            </a>
<!--	            <button id="download-rewind" class="btn smart-secondary" @click="download">-->
<!--		            Download Gambar-->
<!--	            </button>-->
<!--	            <button id="share-rewind" class="btn smart-secondary" @click="shareImage" v-if="userAgent !== ''">-->
<!--		            Share-->
<!--	            </button>-->

            </div>

	        <div class="d-flex justify-content-center align-items-center h-100">
		        <div id="loading-image">
			        <span class="spinner-border spinner-border-lg f-c-midgrey"
                        role="status"
                        aria-hidden="true"
			        ></span>
		        </div>
		        <img class="img-fluid" id="image-rendered" style="padding: 0 40px; height: 80vh" :src="imgRendered" alt="">
	        </div>

            <div class="preview-content montserrat" id="preview-content">
                <div class="preview-logo">
                    <img src="../../assets/img/achievement2023/Image-12.png" style="width: 100px"/>
                </div>
                <div class="preview-title">
                    {{nama_owner}},
                </div>
                <div class="preview-subtitle">
                    <b>{{year}}</b> adalah tahun yang penuh dengan <b>perjuangan</b> yang menghasilkan
                </div>
                <div class="preview-board">
                    <div class="row d-flex justify-content-center mx-0">
                        <div class="col-12 text-center p-d-12">
                            <span class="f-bold f-c-white rounded-pill bg-warning" style="font-size: 18px; padding: 2px 15px;">{{detail.count_transaksi | decimal}}</span>
                            <div class="f-regular f-12 f-c-white" style="margin-top: 2px">Transaksi</div>
                        </div>

                        <div v-for="(item, index) in imageDataDetails" :key="index" class="col-4 text-center p-y-8 px-2">
                            <div
                                class="f-bold rounded-pill m-d-2"
                                style="font-size: 10px; background-color: #7995FF; padding: 4px 0;"
                                v-html="item.value" 
                            />
                            <div class="f-regular f-c-white" style="font-size: 10px">{{item.unit}}</div>
                        </div>
                    </div>
                </div>

                <div class="preview-footer">
                    <img src="../../assets/img/achievement/footers.png" alt="">
                </div>

            </div>

	        <div class="preview-handle">
		        <div class="position-absolute vw-100" style="bottom: 0">
			        <div class="d-flex-between-center p-x-12 p-y-20 w-limit2">
				        <div class="p-x-8 w-100" v-if="userAgent !== ''">
					        <button class="d-flex justify-content-center align-items-center btn btn-light btn-block m-0" @click="shareImage">
						        <div class="icon-16 icon-share-black m-r-8"></div>
						        Share...
					        </button>
				        </div>
				        <div class="p-x-8 w-100">
					        <button class="d-flex justify-content-center align-items-center btn btn-light btn-block m-0" @click="download">
						        <div class="icon-16 icon-download-black m-r-8"></div>
						        Download
					        </button>
					    </div>
			        </div>
		        </div>
	        </div>

        </div>


	    <div class="preview-wrapper-2" style="background: #506DD8">
		    <div class="preview-handle">
			    <a id="close-rewind-2" href="javascript:void(0)" @click="closePreview2">
				    <img src="@/assets/icons/close-white.svg" alt="">
			    </a>
		    </div>

		    <div class="preview-board">
		        <section class="splide vandel-splide">
                    <div class="splide__track">
                        <ul class="splide__list">
                            <li class="splide__slide">
                                <img
                                    src="@/assets/img/achievement2023/vandel-1.png"
                                    alt=""
                                >
                            </li>
                            <li class="splide__slide">
                                <img
                                    src="@/assets/img/achievement2023/vandel-2.png"
                                    alt=""
                                >
                            </li>
                            <li class="splide__slide">
                                <img
                                    src="@/assets/img/achievement2023/vandel-3.png"
                                    alt=""
                                >
                            </li>
                        </ul>
			        </div>
                </section>
			</div>

		    <div class="preview-handle piagam">
			    <div class="" style="">
				    <div class="w-limit2">
                        <div class="f-regular f-14 f-c-white text-center pb-3">
                            Ini adalah contoh piagam yang akan Anda terima. Anda bisa request data yang ingin ditampilkan.
                        </div>
                        <button class="d-flex justify-content-center align-items-center btn btn-light btn-block m-0 f-c-primary" @click="toCustomerService" style="gap: 14px">
                            <i class="fa fa-whatsapp" aria-hidden="true"></i>
                            <span>Pesan piagam sekarang</span>
                        </button>
				    </div>
			    </div>
		    </div>

	    </div>
    </div>

</template>

<script>
import { set } from 'vue';
import SOModalConfirm from '@/so-components/global/modal/SOModalConfirm.vue';
export default {
    components: { SOModalConfirm },
        name: "Rewind",
        data() {
            return {
                output: null,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
                achieve: null,
                wait: false,
                outlet_photo_profile: "",
                nama_owner: "",
                dataowner:null,
                dataoutlet:null,
                detail: {
                    bayar_qris: 0,
                    daily_average: 0,
                    new_customer: 0,
                    top1_layanan: "layanan",
                    outlet_fav: [],
                    count_self_service: null,
                    count_transaksi: 0,
                    customer_visit: 0,
                    daily_average: 0,
                    email: "",
                    idowner: "",
                    nama: "",
                    outlet_1: "",
                    outlet_1_url: "",
                    outlet_2: null,
                    outlet_3: null,
                    qty_kg: 0,
                    qty_koin: null,
                    qty_luas: 0,
                    qty_satuan: 0,
                    top1_layanan: "Paket Cuci + Setrika lor",
                    top_month: 1
                },
	            userAgent: "",

	            year: 2023,
	            imgRendered: null,
                splideIndex: 0,
                maxSplide: 0,
                vandelSplide: null,
            }
        },
        mounted() {
            this.maxSplide = $("#main-slide > .splide__slide").length - 1
            $(".slide, #main-slide > .splide__slide, .scroll-indicator").hide()
	        this.getUserAgent();
            this.getdetailowner();
            $("#nav-bottom").hide();
	        $("#view-screen").removeClass("view-screen").addClass("m-0")
	        setTimeout(() => {
		        $(".sidebar-menu").hide();
	        }, 200)
        },
        computed: {
            top_month() {
                return this.$moment().month(this.detail.top_month).format('MMMM')
            },
            imageDataDetails() {
                let data = [];
                const detailLayanan = this.detail
                if (detailLayanan.new_customer > 0) {
                    data.push({
                        value: `${(this.$options.filters.decimal(detailLayanan.new_customer.toFixed(0)))}`,
                        unit: 'Pelanggan'
                    })
                }
                if (detailLayanan.qty_kg > 0) {
                    data.push({
                        value: `${(this.$options.filters.decimal(detailLayanan.qty_kg.toFixed(0)))} Kg`,
                        unit: 'Pakaian'
                    })
                }
                if (detailLayanan.qty_satuan > 0) {
                    data.push({
                        value: this.$options.filters.decimal(detailLayanan.qty_satuan.toFixed(0)),
                        unit: 'Satuan'
                    })
                }
                if (detailLayanan.qty_luas > 0) {
                    data.push({
                        value: `${this.$options.filters.decimal(detailLayanan.qty_luas.toFixed(0))} m<sup>2`,
                        unit: 'Karpet'
                    })
                }
                if (detailLayanan.qty_koin > 0) {
                    data.push({
                        value: this.$options.filters.decimal(detailLayanan.qty_koin.toFixed(0)),
                        unit: 'Koin'
                    })
                }
                if (detailLayanan.count_self_service > 0) {
                    data.push({
                        value: this.$options.filters.decimal(detailLayanan.count_self_service.toFixed(0)),
                        unit: 'Self Service'
                    })
                }
                if (this.detail.bayar_qris > 0) {
                    data.push({
                        value: this.$options.filters.decimal(this.detail.bayar_qris.toFixed(0)),
                        unit: 'Pendapatan QRIS'
                    })
                }
                return data;
            }
        },
        methods: {
            onClickPage(event) {
                console.log(event.clientX);
                if (event.clientX < 100) {
                    this.pressLeft()
                } else {
                    this.pressRight()
                }
            },
            pressLeft() {
                if (this.splideIndex > 0) {
                    this.splideIndex--
                }
            },
            pressRight() {
                if (this.splideIndex < this.maxSplide) {
                    this.splideIndex++
                }
            },
	        getUserAgent() {
		        var iosDevice = !!navigator.userAgent.match(/iPhone|iPod|iPad/i)
		        var androidDevice = !!navigator.userAgent.match(/Android/i)
		        if (iosDevice) {
			        this.userAgent = "ios"
		        } else if (androidDevice) {
			        this.userAgent = "android"
		        } else {
			        this.userAgent = ""
		        }
				console.log(this.userAgent)
	        },
            async bagikan() {
                $(".preview-wrapper").show();
                const el = $("#preview-content")[0] //this.$refs.printMe;


                // add option type to get the image version
                // if not provided the promise will return
                // the canvas.
                const options = {
                    type: 'dataURL'
                }
                var imgageData = await this.$html2canvas(el, options);
                // var imgageData = getCanvas.toDataURL("image/png");
                // Now browser starts downloading it instead of just showing it
                var newData = imgageData.replace(/^data:image\/png/, "data:application/octet-stream");
                this.output = newData
                $('.ach-dropdown').slideDown(300)
                // this.$refs.printMe.click()
                var that = this
                setTimeout(function () {
                    that.$refs.printMe.click()

                }, 1000)
            },
	        async bagikanV2() {
						return
		        $(".preview-wrapper").fadeIn(300);
				if (this.imgRendered === null) {
					this.imgRendered = await this.generateImage()
					$("#preview-content").hide()
					$("#loading-image").hide()
					$("#image-rendered").show()
				}
	        },
	        async generateImage() {
		        const el = $("#preview-content")[0]
		        const options = {
			        type: 'dataURL'
		        }
		        return await this.$html2canvas(el, options);
	        },
	        async download() {
				// const imageData = await this.generateImage()
		        // this.output = imageData.replace(/^data:image\/png/, "data:application/octet-stream");
		        this.output = this.imgRendered.replace(/^data:image\/png/, "data:application/octet-stream");
		        $('.ach-dropdown').slideDown(300)
		        // this.$refs.printMe.click()
		        var that = this
		        setTimeout(function () {
			        that.$refs.printMe.click()

		        }, 1000)
	        },
	        urltoFile(url, filename, mimeType){
		        return (fetch(url)
				        .then(function(res){return res.arrayBuffer();})
				        .then(function(buf){return new File([buf], filename,{type:mimeType});})
		        );
	        },
	        async shareImage() {
		        // const imageData = await this.generateImage()
		        // const imageDataFile = await this.urltoFile(imageData, "smartlink-rewind.png", "image/png")
		        const imageDataFile = await this.urltoFile(this.imgRendered, "smartlink-rewind.png", "image/png")
		        if (navigator.canShare && navigator.canShare({ files: [imageDataFile] })) {
			        navigator.share({
				        files: [imageDataFile],
				        title: 'Smartlink Rewind',
				        text: 'Smartlink Rewind',
			        })
				        .then(() => {
					        console.log('Share was successful.')
				        })
				        .catch((error) => {
					        console.log('Sharing failed', error)
					        // alert("Gagal, coba lagi")
				        })
		        } else {
			        console.log(`Your system doesn't support sharing files.`);
			        // alert("Terjadi kesalahan, coba lagi")
			        this.download()
		        }

		        try {
			        const response = await this.$axios.post(this.$baseurl + '/masterData/dashboard/update_share_count_kilas_balik', null, this.requestHeaders);
			        if (response.data.code === 200) {
				        if (response.data.status === true) {
					        console.log("shared")
				        }
			        }
		        } catch (e) {
			        // console.log(e)
		        }
	        },
            closePreview() {
                $('.preview-wrapper').fadeOut(300)
            },
	        openPreview2() {
		        $(".preview-wrapper-2").fadeIn(300);
	        },
	        closePreview2() {
		        $('.preview-wrapper-2').fadeOut(300)
	        },
            toCustomerService() {
                const link = "https://api.whatsapp.com/send/?phone=6281216457251&text=Halo%20SmartCare" +
                    "%2C%0Asaya%20mau%20pesan%20piagam%20achievement%20"+ this.year +"%2C%0A" +
                    "%20%3A%0ANama%20%3A%20" +this.dataowner.nama+
                    "%0Aemail%20%3A%20" +this.dataowner.email+
                    "%20%0Atelp%20%3A%20" +this.dataowner.telp+
                    "%20%0A%0A";
                const flutterConfig = JSON.parse(localStorage.getItem('flutterConfig'))
                if (this.isWebview() && flutterConfig.platform !== 'web') {
                    // window.location = 'intent:' + link + '#Intent;package=com.whatsapp;end';
                    this.$refs.pesanPiagam.open()
                    this.flutterSendWa('6281216457251', `Halo SmartCare, saya mau pesan piagam achievement ${this.year}, : Nama : ${this.dataowner.nama} email : ${this.dataowner.email} telp : ${this.dataowner.telp}`)

                } else {
                    window.open(link, '_blank');
                }
            },
            goRouteNotif: function (route) {
                this.$router.push({
                    name: route
                })
            },
            dashboard() {
                $("#nav-bottom").show();

                this.$router.push({
                    name: 'dashboard'
                })
            },
            ulangi() {
                this.splideIndex = 0
            },
            async getInfo() {
                let idowner = localStorage.getItem('idowner');
                try {
                    const response = await this.$axios.get('https://achievement-2023-fljnd6wana-de.a.run.app/?idowner=' + idowner);
                    this.detail = response.data
                    this.detail.outlet_fav = [
                        this.detail.outlet_1,
                    ]
                    if (this.detail.outlet_2) this.detail.outlet_fav.push(this.detail.outlet_2)
                    if (this.detail.outlet_3) this.detail.outlet_fav.push(this.detail.outlet_3)

                    $(".view-screen").css('cssText', 'margin: 0px auto 0px 0px;  width: auto;');
                    // this.splider();
                    $(".slide, .scroll-indicator").show();
                    $("#main-slide > .splide__slide").eq(this.splideIndex).show();
                    $(".load-data-rewind").hide();
                    this.initVandelSlide()
                    setTimeout(() => {
                        $("#sonar, #welcome-text, #welcome-image").addClass("animate");
                        $("#main-slide > .splide__slide").eq(this.splideIndex).addClass("active-slide")
                    }, 1000)
                } catch (e) {
                    $(".load-data-rewind").hide();
                    alert("Coba lagi, Gagal mengambil data. " + e);
                    console.log('error', e);
                }
            },
            async getdetailowner() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner',
                        this.requestHeaders);
                    var dataowner = response.data.data
                    if (response.data.status === true) {
                        this.dataowner=dataowner
                        this.nama_owner = dataowner.nama
                        if(this.dataowner.created_at > `${this.year}-11-30 00:00:01`){
                            alert("Mohon maaf, halaman ini hanya untuk owner yang memiliki transaksi di tahun " + this.year);
                            this.dashboard()
                        }else{
                            this.getInfo()
                        }
                    }
                } catch (e) {
                    alert("gagal mengambil informasi owner" + e);
                }
            },
            scroll() {
                window.onscroll = () => {
                    let visible = this.checkVisible("#end-menu-ekspor")

                    if (visible) {
                        $(".btn-more").hide();
                    } else {
                        $(".btn-more").show();
                    }
                }
            },
            checkVisible(elm, evalType) {

                evalType = evalType || "visible";

                var vpH = $(window).height(), // Viewport Height
                    st = $(window).scrollTop(), // Scroll Top
                    y = $(elm).offset().top,
                    elementHeight = $(elm).height();

                if (evalType === "visible") return ((y < (vpH + st)) && (y > (st - elementHeight)));
                if (evalType === "above") return ((y < (vpH + st)));
            },
            initVandelSlide() {
                let that = this
                that.vandelSplide = new Splide('.vandel-splide', {
                    arrows: false,
                    width: '100vw',
                    perPage: 1,
                }).mount()
            }
        },
        watch: {
            splideIndex(newIndex, oldIndex) {
                $("#main-slide >  .splide__slide").eq(oldIndex).addClass("exit-slide");
                setTimeout(() => {
                    $(".slide *").removeClass("active-slide");
                    $(".slide *").removeClass("exit-slide");
                }, 500);
                setTimeout(() => {
                    $("#main-slide > .splide__slide").hide();
                    $("#main-slide > .splide__slide").eq(newIndex).show();
                    $("#main-slide > .splide__slide").eq(newIndex).addClass("active-slide");
                }, 500);
            }
        },

		beforeDestroy() {
			$("#view-screen").addClass("view-screen").removeClass("m-0")
			$("#nav-bottom").show();
			if (this.userAgent === "") {
				$(".sidebar-menu").show();
			}
		}
    }

    // alert($(".nav-bottom--inner").outerHeight())
</script>


<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;1,700&display=swap');
    .f-montserrat {
        font-family: 'Montserrat', sans-serif;
    }
    #achievement-page {
        position: relative;
    }

    #rewind {
        background: #506DD8;
    }

    .f-c-primary {
        color: #506DD8;
    }
    .f-c-accent {
        color: #FEC601;
    }

    #service-summary li {
        color: #FEC601;
    }

    .exit-slide #service-summary {
        opacity: 1 !important;
        margin-left: -310px;
        max-width: 100%;
    }

    .share {
        margin-top: 100px;
    }

    .share .share__header {
        font-size: 25px;
        font-weight: 800;
    }

    .share .share__body {
        max-width: 295px;
        margin: 10px auto 26px;
    }

    .share .btn {
        font-weight: 600 !important;
    }

    .content #top-laundry {
        font-size: 20px;
        font-weight: 600;
        display: flex;
        flex-direction: column;
        justify-content: center;   
    }

    .content .rounded-circle {
        width: 541px;
        height: 541px;
        bottom: -381px;
    }

    .content .prelude {
        padding-top: 130px;
        font-weight: 800;
        font-size: 24px
    }

    .content .content-item {
        margin: 0x auto;
        padding-top: 80px;
        max-width: 800px;
        font-size: 20px;
        line-height: 32px;
    }

    #top-laundry img {
        width: 180px;
    }

    .icon-x-white {
        background-image: url('../../assets/img/achievement/close-x-white.svg');
    }

    .icon-trophy {
        background-image: url('../../assets/img/achievement/trophy-blu.svg');
    }

    .icon-share-white {
	    background-image: url('../../assets/img/achievement2021/share-white.svg');
    }

    .icon-share-black {
	    background-image: url('../../assets/img/achievement2021/share-black.svg');
    }

    .icon-download-black {
	    background-image: url('../../assets/img/achievement2021/download-black.svg');
    }

    .icon-whatsapp-black {
	    background-image: url('../../assets/img/achievement2021/whatsapp-black.svg');
    }

    .icon-share {
        background-image: url('../../assets/img/achievement/share.svg');
    }

    .w-limit2 {
        max-width: 320px;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        position: relative;
    }

    .w-limit3 {
	    max-width: 800px;
	    margin-left: auto;
	    margin-right: auto;
	    width: 100%;
	    position: relative;
    }

    .achievement-page {
        color: #ffffff;
        background: #506DD8;
    }

    .achievement-page .top-right {
        position: absolute;
        right: 20px;
        top: 16px;
    }

    .achievement-page .op-75 {
        opacity: 0.75;
    }

    .achievement-page .f-28,
    .f-32 {
        font-weight: bold;
        font-size: 28px;
        line-height: 140%;
        letter-spacing: -0.04em;
    }

    .achievement-page .f-32 {
        font-size: 32px;
    }

    .achievement-page .f-20 {
        font-size: 20px;
        line-height: 160%;
        letter-spacing: -0.02em;
    }

    .achievement-page .f-18 span {
        font-weight: bold;
        display: inline-block;
        color: #4AE7E1;
        text-shadow: 0px 0px 2px rgba(255, 255, 255, 0.5);
    }

    .achievement-page .f-20 span.no-underline {
        text-decoration: none;
    }

    .achievement-page .f-18 {
        line-height: 160%;
    }

    .achievement-page .content-desc {
        /* margin-top: 50%; */
        min-height: 50%;
        padding-top: 20px;
        padding-bottom: 60px;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }

    .achievement-page .separator-mini {
        height: 1px;
        width: 40px;
        margin-left: auto;
        margin-right: auto;
        background: #ffffff;
    }

    .flex {
        display: flex;
    }

    .flex-col {
        flex-direction: column;
    }

    .m-l-12 {
        margin-left: 12px !important;
    }

    .text-yl {
        color: #FFFFFF;
	    text-shadow: 0px 0px 2px rgba(255, 255, 255, 0.5);
    }

    /* --- buttons --- */

    .achievement-page .btn.smart-primary {
        background-color: #ffffff;
        color: #506DD8;
    }

    .achievement-page .btn.smart-secondary {
        color: #ffffff;
        border-color: rgba(255, 255, 255, 0.5);
        background: none;
    }

    .achievement-page .btn-outline-small {
        border-color: rgba(255, 255, 255, 0.5);
        color: #ffffff;
    }

    .achievement-page .btn-outline-small.has-icon,
    .achievement-page .btn.smart-primary.has-icon,
    .achievement-page .btn.smart-secondary.has-icon {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .achievement-page .btn.smart-primary,
    .achievement-page .btn.smart-secondary,
    .achievement-page .btn-groupx {
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
        display: block;
    }

    .achievement-page .btn-groupx {
        display: flex;
    }

    .achievement-page .flex > .btn.smart-primary,
    .achievement-page .flex > .btn.smart-secondary {
        max-width: none;
    }

    .achievement-page button.btn-nude {
        background: none;
        border: none;
        padding: 0;
    }

    /* --- header --- */

    .ach-header {
        position: fixed;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        z-index: 1;
        /*width: 100%;*/
        left: 0px;
        right: 0px;
    }

    .ach-header .ach-logo {
        background-image: url("../../assets/img/achievement/smartlink-white.svg");
        height: 24px;
        width: 50%;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: left center;
    }

    /* --- content --- */
    .achievement-page[data-page="0"] #btn-share {
        display: none;
    }

    .ach-wrapper .splide__slide {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        padding: 24px 20px;
        /* text-shadow: 0px 0px 2px rgba(255, 255, 255, 0.5); */
    }

    .ach-wrapper .splide__slide.center {
        justify-content: center;
    }

    .slide .splide__slide {
        height: 100%;
        overflow: hidden;
    }

    .ach-wrapper .splide__slide.center .content-desc {
        padding: 0px;
    }

    .ach-wrapper .splide__slide .illustration {
        text-align: center;
    }

    .ach-wrapper .splide__slide .illustration.first-pg {
        border-radius: 50%;
        overflow: hidden;
    }

    .ach-wrapper .splide__slide .illustration img {
        width: auto;
        max-width: 100%;
        max-height: 320px;
    }

    .ach-wrapper .splide__slide .illustration img.img-lg {
        max-width: calc(100% - 84px);
    }

    .ach-wrapper .splide__slide .illustration.bottom-left {
        position: absolute;
        z-index: -1;
        left: 0;
        bottom: 0;
    }

    .ach-wrapper .splide__slide .first-pg-text {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }

    .ach-wrapper .splide__slide .illustration.first-pg {
        max-height: 100%;
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .circle-animate,
    .illustration.first-pg:before,
    .illustration.first-pg:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1px solid rgba(255, 255, 255, 0.75);
        top: 0;
        left: 0;
        animation-name: scale1;
        animation-duration: 2s;
        animation-iteration-count: infinite;
    }

    @keyframes scale1 {
        0% {
            transform: scale(1.0);
            opacity: 0;
        }

        25% {
            opacity: 1;
        }

        100% {
            transform: scale(1.2);
            opacity: 0;
        }
    }

    @keyframes scale2 {
        0% {
            transform: scale(1.1);
            opacity: 0;
        }

        25% {
            opacity: 1;
        }

        100% {
            transform: scale(1.4);
            opacity: 0;
        }
    }

    @keyframes scale3 {
        0% {
            transform: scale(1.2);
            opacity: 0;
        }

        25% {
            opacity: 1;
        }

        100% {
            transform: scale(1.6);
            opacity: 0;
        }
    }
    .circle-animate {
        border-color: rgba(255, 255, 255, 0.5);
        animation-name: scale2;
    }
    .illustration.first-pg:after {
        border-color: rgba(255, 255, 255, 0.25);
        animation-name: scale3;
    }

    .ach-wrapper .splide__slide ul {
        margin: 16px 0px;
        padding: 0px;
        list-style-type: none;
    }

    .ach-wrapper .splide__slide ul li:not(:last-child) {
        margin-bottom: 4px;
    }

    .ach-footer {
        position: relative;
        bottom: 20px;
        align-items: center;
        transition: all 0.5s;
        max-width: 100%;
    }

    .ach-footer .scroll-indicator {
        position: absolute;
        display: flex;
        align-content: center;
        white-space: nowrap;
        transition: all 0.5s;
        right: 20px;
        gap: 14px;
        bottom: 0px;
        transition-property: all;
    }

    .ach-footer .scroll-desc {
        opacity: 75;
        transition: all .5s;
    }

    .scroll-indicator.right {
        right: 20px !important;
        transform: unset !important;
        bottom: -30px !important;
    }

    .achievement-page[data-page="0"] .ach-footer{
        bottom: 54px;
    }

    .achievement-page[data-page="0"] .ach-footer .scroll-indicator{
        bottom: 0px;
        right: 50%;
        transform: translateX(50%);
    }

    .achievement-page.last-page .ach-footer {
        opacity: 0;
    }

    .page-num--wrapper:before,
    .page-num--wrapper:after {
        width: 24px;
        height: 24px;
        content: '';
        background: url('../../assets/img/achievement/chevron-up.svg') no-repeat center;
        background-size: contain;
    }

    .page-num--wrapper:after {
        transform: rotate(180deg);
    }

    .ach-footer svg path {
        animation: fadeDown 2s infinite;
    }

    .ach-footer svg path:nth-child(2) {
        animation-delay: .2s;
    }

    @keyframes fadeDown {
        0% {
            opacity: 0;
            transform: translateY(-20px)
        }

        50% {
            opacity: 1;
        }

        100% {
            opacity: 0;
            transform: translateY(0px);
        }
    }

    /* --- some tweaks --- */
    .modal-open .modal.mod {
        left: auto !important;
        max-width: none;
    }

    .achievement-page .modal {
        color: black;
    }

    .achievement-page .modal-img {
        text-align: center;
        /* background: blue; */
        padding: 30px;
        background: linear-gradient(300deg, #0C3483 0%, #A2B6DF 100%, #6B8CCE 100%);
    }

    .achievement-page .modal-img img {
        width: auto;
        max-height: 240px;
    }

    ul.ach-dropdown {
        display: none;
        position: absolute;
        right: 20px;
        top: 70px;
        padding: 0px;
    }

    ul.ach-dropdown li {
        text-decoration: none;
        list-style: none;
        border: solid 1px;
    }

    ul.ach-dropdown li a {
        padding: 5px 10px;
        display: inline-block;
    }


    /*preview downloadn*/

    .preview-wrapper,.preview-wrapper-2  {
        display: none;
        position: fixed;
	    height: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
	    background: rgba(0, 0, 0, 0.85);
	    z-index: 10;
    }

    .preview-content {
        margin: 0px auto;
        padding:20px;
        color:#fff;
	    width: 360px;
	    height: 640px;
        position: relative;
        background-color: #506DD8;
    }
    .preview-handle {
        margin: 0px auto;
        /*padding:20px;*/
        color:#fff;
        /*width: 360px;*/

        /*      width: 630px;
        height: 1120px;
     */
        position: relative;
    }
    .preview-handle.piagam{
        margin: 0px auto;
        color:#fff;
        position: absolute !important;
        bottom: 20px;
        width: 320px;
        left: 50%;
        transform: translateX(-50%);
    }

    a#download-rewind {
        position: absolute;
        z-index: 9;
        right: 20px;
        top: 50px;
    }
    button#download-rewind {
	    position: absolute;
	    z-index: 9;
	    right: 20px;
	    top: 50px;
    }
    button#share-rewind {
	    position: absolute;
	    z-index: 9;
	    right: 180px;
	    top: 50px;
    }
    a#close-rewind {
        position: absolute;
        z-index: 9;
        left: 20px;
        top: 20px;
    }
    a#close-rewind-2 {
	    position: absolute;
	    z-index: 9;
	    left: 20px;
	    top: 20px;
    }


    .preview-logo {
        margin-top: 32px;
        text-align: center;
        margin-bottom: 20px;
    }

    .preview-title {
        text-transform: capitalize;
        padding-bottom: 12px;
        font-weight: 800;
        font-size: 18px;
        line-height: 140%;
        text-align: center;
        letter-spacing: -0.04em;
    }

    .preview-subtitle {
        font-size: 16px;
        line-height: 160%;
        /* or 22px */
        text-align: center;
    }

    .preview-board {
        margin-top: 12px;
        margin-bottom: 24px;
    }

    .preview-footer {
        position: absolute;
        bottom: 0px;
        left: 0;
        right: 0;

    }

    .preview-footer img {
        max-width: 100%;
        margin: 20px;
        width: calc(100% - 40px);
    }


    .preview-handle .btn.smart-secondary {
        width: auto;
        border: solid 1px #fff;
        background: transparent;
        color: #fff;
    }

    .slide {
        height: 100vh;
    }

    .slide-welcome .w-limit2 {
        max-width: 221px;
    }
    .slide-welcome #welcome-text {
        font-weight: 700;
        min-width: 297px;
        text-align: center;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 94px;
        font-size: 24px !important;
        line-height: 38px;
    }

    #welcome-image {
        position: absolute;
        bottom: 240px;
        left: 50%;
        transform: translateX(-50%);
        width: 258px;
        max-width: 575px;

    }
    .caption:not(.prelude) {
        padding-left: 20px;
        padding-right: 20px;
    }

    #welcome-text, #welcome-image, .caption {
        transition-property: all;
        transition-duration: 500ms;
        opacity: 0;
    }

    .active-slide #welcome-text, .active-slide #welcome-image, .active-slide .caption {
        opacity: 100;
    }

    .exit-slide .caption {
        opacity: 0;
    }

    .exit-slide #welcome-text {
        left: 0;
        transform: translateX(-100%);
    }

    .exit-slide #welcome-image {
        opacity: 0;
    }

    #welcome-text span {
        color: #FEC601;
    }

    .content .image-container {
        position: absolute;
        width: 100vw;
        bottom: 0;
    }
    @media only screen and (max-width: 400px) {
        .caption {
            font-size: 16px !important;
            line-height: 150% !important;
        }
        .active-slide #img-flower {
            transform: scale(0.6) translateX(-55%) translateY(35%) !important;
        }
        #slide-2 p, .action-group, .preview-handle {
            padding: 0 12px;
        }
        .active-slide #img-3 {
            transform: scale(0.6) translateX(-90%) translateY(-35%) !important;
        }
        .active-slide #image-4a,
        .active-slide #image-4c {
            transform: scale(0.6) !important;
        }
        .active-slide #image-4b {
            left: 50% !important;
            transform: translateX(-70%) scale(0.6) !important;
        }
        .active-slide #image-5 {
            transform: scale(0.7) translateY(20%) !important;
        }
        .active-slide #image-6 {
            transform: scale(0.7) translateY(20%) translateX(-70%) !important;
        }
        .active-slide #image-7 {
            transform: scale(0.7) translateY(20%) translateX(-70%) !important;
        }
        .active-slide #image-8 {
            transform: scale(0.7) translateY(20%) translateX(-70%) !important;
        }
    }


    @media (min-width: 769px) {
        .ach-footer,
        .ach-header {
            width: auto !important;
            max-width: 100% !important;
            /* margin-left: 350px; */
        }
        #welcome-image {
            width: 400px;
        }
		#slide-2 p {
			width: 540px;
		}
		#slide-3 .caption {
			max-width: 480px;
			padding-left: 5vw;
			margin-left: auto;
		}
		#img-3 {
			bottom: -10vh;
		}
		.active-slide #img-3 {
			left: 5vw;
		}

		#slide-4 p {
			font-size: 24px;
			line-height: 160%;
		}
		#image-4a, #image-4b, #image-4c {
			scale: 1.45;
		}
        #slide-5 .caption {
            width: 511px;
            line-height: 150%;
            margin-left: auto;
            padding-top: 30vh;
        }
        #slide-5 .w-limit3 {
            margin-right: 10vw;
        }
        #slide-6 .caption {
            width: 618px;
            margin-left: auto;
            line-height: 160%;
        }
        #slide-6 .w-limit3 {
            max-width: 80vw;
        }
        #image-6 {
            left: 20% !important;
        }
        .active-slide #image-6 {
            bottom: 50% !important;
            transform: translateY(50%) scale(1.1 ) !important;
        }
        .exit-slide #image-6 {
            bottom: -1014px !important;
        }
		.active-slide #image-4a {
			left: calc((100% - 760px)/2) !important;
		}
		.active-slide #image-4c {
			right: calc((100% - 760px)/2) !important;
		}
        .active-slide #image-5 {
            animation-name: notaanimation2 !important;
        }

        @keyframes notaanimation2 {
            0%   { left: -580px; transform: scale(1.5);}
            40%  { left: -280px; transform: scale(1.5);}
            50%  { left: -280px; transform: scale(1.5);}
            100% { left: -280px; transform: scale(2);}
        }
        #slide-8 .w-limit3 {
            margin: unset;
            margin-left: auto;
            padding-top: 35vh;
        }
        #slide-8 .caption {
            margin: auto;
            width: 460px;
        }
        #image-8 {
            left: 10% !important;
            width: 25vw !important;
        }
        .active-slide #image-8 {
            bottom: 50% !important;
            transform: translateY(50%) !important;
        }
        #slide-9 .position-relative {
            transform: scale(1.5);
        }
        #slide-9 .caption{
            padding-top: 300px !important;
        }
        #image-10 {
            scale: 1.5;
            top: 180px !important;
            transform: translateX(10%);
        }
        #slide-11 .content-item {
            place-items: unset !important;
        }
        #image-11 {
            scale: 1.7;
            bottom: -100px !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
        }
        .slide-welcome .w-limit2 {
            max-width: 320px;
        }

	    .achievement-page .f-16 {
		    font-size: 24px;
	    }

	    .achievement-page .f-18 {
            font-size: 32px;
        }
	    .achievement-page .f-32 {
		    font-size: 48px;
	    }

        .content .content-item {
            text-align: left;
            padding-top: 173px;
            font-size: 32px;
            font-weight: 600;
            line-height: 51.2px;
        }

        .content .content-item.content-item-2 {
            text-align: left;
            padding: 0;
            display: flex;
            place-items: center;
        }

        .content .prelude {
            padding-top: 130px;
            font-weight: 700 !important;
            font-size: 48px;
        }
        
        .content .rounded-circle.circle-car {
            display: none;
            width: 110%;
            height: 782px;
            bottom: -391px;
        }

        #thank-text br {
            display: none;
        }

        .content #top-laundry {
            font-size: 32px;
        }

        .share .share__header {
            font-size: 50px;
        }

        .share .share__body {
            font-size: 30x;
            max-width: 619px;
            margin: 10px auto 26px;
        }

        .w-limit2.share {
            max-width: 688px;
        }

        #top-laundry img {
            width: 320px;
        }
        #sonar div {
            bottom: -20vw !important;
        }
        
        .animate #sonar-1{
            height: 90vw !important;
        }
        .animate #sonar-2{
            height: 105vw !important;
        }
        .animate #sonar-3{
            height: 120vw !important;
        }

        #slide-2 .caption {
            margin-left: 40vw;
            padding-top: 45vh;
        }

        .active-slide #img-flower {
            transform: scale(1.2) translateX(-24%) !important;
        }

        .vandel-splide img {
            padding: 0 39vw !important;
        }
    }

    @media (min-width: 768px) and (max-height: 900px) {
        .content #top-laundry{
            padding-top: 0;
        }
        .slide-welcome .w-limit2 {
            max-width: 221px;
        }
        .content .prelude {
            font-size: 35px;
        }
    }

    .bg-page {
	    background-position: center !important;
	    background-size: cover !important;
    }

    .bg-page.bg-page-2 {
        background-color: #506DD8;
	    
    }

    .bg-page.bg-page-3 {
	    background-color: #506DD8;
    }

    .bg-page.bg-page-4 {
	    background: url("./../../assets/img/achievement2021/hal-04.jpg");
    }

    .bg-page.bg-page-6 {
	    background: url("./../../assets/img/achievement2021/hal-06.jpg");
    }

    .bg-page.bg-page-7 {
	    background: url("./../../assets/img/achievement2021/hal-07.jpg");
    }

    .f-c-blue-rewind {
	    color: #4AE7E1;
    }

    .page-oultet-layer {
	    height: 100%;
	    width: 100%;
	    position: absolute;
	    top: 0;
	    background: #283470e6;
    }

    .bg-outlet-default {
	    background: url("../../../src/assets/gambar/Rectangle43.svg");
    }
    .load-data-rewind {
        padding-top: 200px;
        z-index: 9;
        margin-right: auto;
        margin-left: auto;
        font-size: 20px;
    }
    .note-data-rewind {
        position: absolute;
        bottom: 7px;
        left: 20px;
        font-size: 12px;
    }
    #sonar {
        transform: translateX();
    }
    #sonar div{
        position: fixed;
        background: rgba(255, 255, 255, 0.04);
        border-radius: 100%;
        left: 50%;
        transform: translate(-50%, 50%);
        bottom: 0;
        height: 100px;
        transition-property: all;
        transition-duration: 2000ms;
        aspect-ratio: 1/1;
    }
    .animate #sonar-1{
        height: 60vh;
    }
    .animate #sonar-2{
        height: 80vh;
    }
    .animate #sonar-3{
        height: 100vh;
    }

    #slide-2 img {
        position: absolute;
        bottom: 0;
        left: 0;
        overflow: hidden;
        transition-property: all;
        transition-duration: 500ms;
    }

    #slide-2 #img-flower {
        height: 0px;
        transform: translateX(-38%);
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
        animation-duration: 4s;

    }

    .active-slide #img-flower {
        animation-name: floweranimation;
    }

    .exit-slide #img-flower {
        transform: translateX(-100%) !important;
    }

    @keyframes floweranimation {
        0%   { height: 0px; }
        30%  { height: 412px; }
        40%  { height: 412px; }
        100% { height: 487px; }
    }

    #img-3 {
        position: absolute;
        height: 861px;
        left: 50%;
        transform: translateX(-100%);
        transition-property: all;
        transition-duration: 500ms;
    }

    .active-slide #img-3 {
        transform: translateX(-57%);
    }

    .exit-slide #img-3 {
        transform: translate(-57%, 57%);
    }

    #slide-4 p span {
        color: #FEC601;
    }

    .exit-slide#slide-4 .caption {
        opacity: 1 !important;
        margin-top: -500px !important;
    }

    #slide-4 img,
    #slide-5 img,
    #slide-6 img,
    #slide-7 img,
    #slide-8 img,
    #slide-10 img,
    #slide-11 img {
        position: absolute;
        transition-property: all;
        transition-duration: 500ms;
    }

    #image-4a {
        left: -185px;
        bottom: -115px;
    }

    #image-4b {
        left: 50%;
        bottom: -189px;
        transform: translateX(-75%);
    }

    #image-4c {
        right: -172px;
        bottom: -106px;
    }

    .active-slide #image-4a { left: -45px; }
    .active-slide #image-4b { bottom: -100px; }
    .active-slide #image-4c { right: -23px; }

    .exit-slide #image-4a { left: -185px; }
    .exit-slide #image-4b { bottom: -189px; }
    .exit-slide #image-4c { right: -172px; }

    #image-5 {
        bottom: -244px;
        left: -580px;
        animation-duration: 4s;
        animation-fill-mode: forwards;
    }

    .active-slide #image-5 {
        animation-name: notaanimation;
    }

    @keyframes notaanimation {
        0%   { left: -580px; transform: scale(1);}
        40%  { left: -280px; transform: scale(1);}
        50%  { left: -280px; transform: scale(1);}
        100% { left: -280px; transform: scale(1.15);}
    }

    .exit-slide #image-5 {
        animation: none;
        left: -700px;
    }

    #image-6 {
        bottom: -414px;
        left: 50%;
        transform: translateX(-50%);
    }

    .active-slide #image-6 {
        bottom: -130px;
    }

    .exit-slide #image-6 {
        bottom: -1014px;
    }

    .exit-slide#slide-6 .caption {
        opacity: 1 !important;
        margin-top: 700px !important;
    }

    #image-7 {
        left: 50%;
        animation-duration: 4s;
        animation-fill-mode: forwards;
    }
    
    .active-slide #image-7 {
        animation-name: medalanimation;
    }

    .exit-slide #image-7 {
        animation: medalexit 500ms forwards;
    }

    @keyframes medalexit {
        from { bottom: 20vh; transform: scale(1.15) translateX(-42.5%) }
        to   { bottom: -300px; transform: scale(1) translateX(-50%); }
    }

    @keyframes medalanimation {
        0%   { bottom: -300px; transform: scale(1) translateX(-50%);}
        40%  { bottom: 20vh; transform: scale(1) translateX(-50%);}
        50%  { bottom: 20vh; transform: scale(1) translateX(-50%);}
        100% { bottom: 20vh; transform: scale(1.15) translateX(-42.5%);}
    }

    #image-8 {
        left: 50%;
        transform: translateX(-50%);
        bottom: -300px;
        opacity: 1;
    }

    .active-slide #image-8 {
        bottom: 50px;
    }

    .exit-slide #image-8 {
        opacity: 0;
    }
    #slide-9 img {
        position: absolute;
        transition-property: all;
        transition-duration: 500ms;
        left: 50%;
    }

    #slide-9 .position-relative {
        margin-top: -220px;
        margin-bottom: 220px;
        transition: all 500ms;
    }

    .active-slide#slide-9 .position-relative {
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .exit-slide#slide-9 div {
        margin-left: -400px;
    }

    #outlet-image {
        border-radius: 100%;
        opacity: 0;
        width: 64px;
        top: 22px;
        transform: translateX(-50%);
        aspect-ratio: 1/1;
        transition: all 500ms;
        transition-delay: 700ms;
    }
    
    .active-slide #outlet-image {
        opacity: 1;
    }

    #image-9 {
        transform: translateX(-50%);
    }

     #image-11 {
        left: 50%;
        transform: translateX(-50%);
        bottom: -100px;
    }

    .active-slide #image-11 {
        bottom: 60px;
    }

    .exit-slide #image-11 {
        transform: translateX(-400px);
    }

    .vandel-splide {
        margin-top: 100px;
    }

    .vandel-splide li {
        text-align: center;
    }

    .vandel-splide img {
        max-width: 100vw;
        padding: 0 0;
        text-align: center;
    }

    .vandel-splide .splide__arrows {
        display: none !important;
    }

</style>